import React, {useEffect} from 'react';
import ProjectForm from '../project-form';
import { GetDefaultTemplate } from '../helpers/project-helpers';

const initialProjectState = {
    Name: '',
    Start: new Date(),
    End: new Date(),
    Members: [],
    allUsers: [],
    Priority: 'Medium',
    ParentTemplateId: '',
    ParentTemplateName: '',
    Tags: "",
    Description: "",
    Status: "Active",
    StrStatus: null,
    Deleted: false,
    Created: null,
    CreatedBy: null,
    CreatedByUserName: null,
    CreatedByUserNameFull: null,
    CreatedByEmail: null,
    Modified: null,
    ModifiedBy: null,
    hasClient: false,
    clientName: null,
    clientID: null,
    userId: null,
    Owner: null,
    projectDocuments: null,
    IsCreateNewUserTasks: false,
    IsCreateNewUserTasksCurrent: false,
    IsMultiOwner: true, // Default to true when no template is selected
    CanTransferOwner: true,
    Owners: [],
};

function ProjectCreate() {

    useEffect(() => {
        const fetchDefaultTemplate = async () => {
            try {
                const defaultTemplate = await GetDefaultTemplate();
                initialProjectState.ParentTemplateId = defaultTemplate.Id ?? '';
                initialProjectState.ParentTemplateName = defaultTemplate?.ProjectType ?? '';
                initialProjectState.IsMultiOwner = initialProjectState.ParentTemplateId ? (defaultTemplate?.IsMultiOwner ?? true) : true;
                initialProjectState.CanTransferOwner = initialProjectState.ParentTemplateId ? (defaultTemplate?.CanTransferOwner !== false) : true;
                const endDate = new Date(initialProjectState.Start);
                endDate.setDate(endDate.getDate() + (defaultTemplate.Days || 0));
                initialProjectState.End = endDate;
            } catch (error) {
                console.error("Failed to fetch default project template", error);
                initialProjectState.ParentTemplateId = '';
                initialProjectState.ParentTemplateName = '';
                initialProjectState.IsMultiOwner = true;
                initialProjectState.CanTransferOwner = true;
                initialProjectState.End = new Date();
            }
        }
        fetchDefaultTemplate();
    }, []);
    return (
        <ProjectForm
            isEdit={false}
            initialProject={initialProjectState}
        />
    );
}

export default ProjectCreate;